var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5999C7.28799 9.5999 6.59196 9.38877 5.99995 8.99319C5.40793 8.59762 4.94651 8.03538 4.67403 7.37756C4.40156 6.71975 4.33027 5.99591 4.46917 5.29758C4.60808 4.59925 4.95095 3.95779 5.45442 3.45432C5.95788 2.95085 6.59934 2.60798 7.29767 2.46908C7.99601 2.33017 8.71985 2.40146 9.37766 2.67394C10.0355 2.94641 10.5977 3.40783 10.9933 3.99985C11.3889 4.59187 11.6 5.28789 11.6 5.9999C11.6 6.95468 11.2207 7.87036 10.5456 8.54549C9.87045 9.22062 8.95478 9.5999 8 9.5999ZM8 0.399902C2.4 0.399902 0 5.9999 0 5.9999C0 5.9999 2.4 11.5999 8 11.5999C13.6 11.5999 16 5.9999 16 5.9999C16 5.9999 13.6 0.399902 8 0.399902Z",
    fill: "#7E8486"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8C9.10457 8 10 7.10457 10 6C10 4.89543 9.10457 4 8 4C6.89543 4 6 4.89543 6 6C6 7.10457 6.89543 8 8 8Z",
    fill: "#7E8486"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.a490029ba3dcc142cf3c05e99007d824.svg";
export { ForwardRef as ReactComponent };